import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { headingProps } from "@features/report/helpers/heading-props";
import { useAppTheme } from "@hooks/useAppTheme";
import { Box, useDevice } from "@memorang/ui";
import { Image } from "expo-image";
import type { ReactNode } from "react";
import { Card, Text } from "react-native-paper";

const BADGE_SIZE = 80;

export const ReportHeroCard = ({
	moduleLabel,
	badge: badgeSlot,
	badgeSource,
	title,
	summaryText,
}: {
	moduleLabel?: string;
	badge?: ReactNode;
	badgeSource?: string | number | { uri: string };
	title: string;
	summaryText: string;
}) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	const badge = badgeSlot ? (
		badgeSlot
	) : badgeSource ? (
		<Image
			source={badgeSource}
			style={{ width: BADGE_SIZE, height: BADGE_SIZE }}
			contentFit="contain"
			alt={moduleLabel ? `${moduleLabel} badge` : "Module badge"}
		/>
	) : (
		<Box
			width={BADGE_SIZE}
			height={BADGE_SIZE}
			borderRadius={BADGE_SIZE / 2}
			alignItems="center"
			justifyContent="center"
			backgroundColor={theme.colors.success.main}
		>
			<Icon
				name="book-open-variant"
				size={32}
				color={theme.colors.white}
				accessible={false}
			/>
		</Box>
	);

	return (
		<Box style={{ marginTop: BADGE_SIZE / 2 }}>
			<Card
				mode="contained"
				style={{ backgroundColor: theme.colors.surfaceVariant }}
			>
				<Box
					alignItems="center"
					paddingTop={BADGE_SIZE / 2 + 16}
					paddingBottom={32}
					paddingHorizontal={24}
					style={{ gap: 8 }}
				>
					{moduleLabel ? (
						<Text
							variant={isMobile ? "titleLarge" : "headlineSmall"}
							style={{
								color: theme.colors.success.main,
								fontWeight: "800",
								letterSpacing: 1,
							}}
							{...headingProps(1)}
						>
							{`${moduleLabel.toUpperCase()} COMPLETE`}
						</Text>
					) : null}
					<Text
						variant={isMobile ? "titleMedium" : "titleLarge"}
						style={{
							color: theme.colors.onSurface,
							fontWeight: "800",
							textAlign: "center",
						}}
						{...headingProps(2)}
					>
						{title}
					</Text>
					{summaryText ? (
						<Text
							variant={isMobile ? "bodyMedium" : "bodyLarge"}
							style={{
								color: theme.colors.onSurfaceVariant,
								textAlign: "center",
								maxWidth: 760,
							}}
							{...headingProps(3)}
						>
							{summaryText}
						</Text>
					) : null}
				</Box>
			</Card>
			<Box
				style={{
					position: "absolute",
					top: -(BADGE_SIZE / 2),
					left: 0,
					right: 0,
					alignItems: "center",
				}}
			>
				{badge}
			</Box>
		</Box>
	);
};
